import { Button, Stack, Text } from '@mantine/core';
import { format } from 'date-fns';

type Props = {
  downgradeAt: string;
  onCancel: () => void;
  loading: boolean;
};

export function DowngradeScheduled({ downgradeAt, onCancel, loading }: Props) {
  return (
    <Stack align="flex-start" gap="md">
      <Text size="sm">
        無料プランへの変更を予約しています。{format(new Date(downgradeAt), 'yyyy/MM/dd HH:mm')}{' '}
        に無料プランに切り替わり、このテナントの API
        キーは使えなくなります。それまでは有料プランのまま使えます。
      </Text>
      <Button variant="outline" loading={loading} onClick={onCancel}>
        無料プランへの変更を取り消す
      </Button>
    </Stack>
  );
}
